import apiClient from "./client";
import { API_CORE } from "../utils/constants";

export async function fetchCategories(signal) {
  const response = await apiClient.get("categories/", { signal });
  return response.data;
}

export async function fetchCategoryLiveStats(signal) {
  const response = await apiClient.get("categories/live-stats/", { signal });
  return response.data;
}

export async function fetchCategoryScore({ slug, userId }, signal) {
  const qs = new URLSearchParams();
  if (slug) qs.set("category", slug);
  if (userId) qs.set("user", userId);
  const res = await fetch(`${API_CORE}/category-score/?${qs.toString()}`, {
    signal,
  });
  if (!res.ok) return { category: slug, score: 0, rank: null };
  return res.json();
}

export async function fetchMyCategoryGamesPlayed(slug, signal) {
  const response = await apiClient.get("category-score/", {
    params: { category: slug },
    signal,
  });
  return Number(response.data?.games_played || 0);
}
